import { FunctionComponent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { Alert, Button } from 'react-bootstrap'
import Icon from 'components/ui/icon'

import Page from 'components/ui/page'
import PageHeader from 'components/ui/pageHeader'
import EmptyState from 'components/ui/emptyState'
import ConfirmationModal from '../../components/modal/confirmationModal'
import HospitalsTable from './components/hospitalsTable'
import * as api from './api.client'
import { AdminHospital } from './types'

const AdminHospitals: FunctionComponent = () => {
  const navigate = useNavigate()
  const [hospitals, setHospitals] = useState<AdminHospital[]>([])
  const [loaded, setLoaded] = useState(false)
  const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false)
  const [errorMessage, setErrorMessage] = useState({ show: false, message: '' })
  const [removingHospital, setRemovingHospital] = useState(false)
  const [removingHospitalId, setRemovingHospitalId] = useState<number>()

  useEffect(() => {
    getHospitals()
  }, [])

  const getHospitals = async () => {
    try {
      const hospitals = await api.getHospitals()
      setHospitals(hospitals)
    } catch (error) {
      setErrorMessage({
        show: true,
        message: 'Erro ao buscar os hospitais.',
      })
    } finally {
      setLoaded(true)
    }
  }

  const addHospital = () => navigate('/hospitals/new')

  const removeHospital = async () => {
    if (!removingHospitalId) {
      return
    }

    try {
      setRemovingHospital(true)
      await api.removeHospital(removingHospitalId)
      await getHospitals()
    } catch (error) {
      setErrorMessage({
        show: true,
        message: 'Erro ao remover o hospital.',
      })
    } finally {
      setRemovingHospital(false)
      setShowRemoveConfirmation(false)
      setRemovingHospitalId(undefined)
    }
  }

  return (
    <Page fill>
      {showRemoveConfirmation && (
        <ConfirmationModal
          message="Você deseja realmente remover o hospital?"
          btnMessage="Remover"
          btnVariant="outline-danger"
          onClose={() => setShowRemoveConfirmation(false)}
          onConfirmation={removeHospital}
        />
      )}

      <PageHeader
        title="Hospitais"
        subtitle="Hospitais integrados à plataforma Clic-repasse."
        actions={
          <Button variant="primary" onClick={addHospital}>
            <Icon name="plus" size={16} />
            Adicionar hospital
          </Button>
        }
      />

      {errorMessage.show && (
        <Alert variant="danger">{errorMessage.message}</Alert>
      )}

      {loaded && hospitals.length === 0 && !errorMessage.show ? (
        <EmptyState
          icon={<Icon name="hospital" size={20} />}
          title="Nenhum hospital cadastrado"
          action={
            <Button variant="primary" onClick={addHospital}>
              <Icon name="plus" size={16} />
              Adicionar hospital
            </Button>
          }
        />
      ) : (
        <HospitalsTable
          hospitals={hospitals}
          removingHospitalId={removingHospital ? removingHospitalId : undefined}
          onRemove={(id) => {
            setShowRemoveConfirmation(true)
            setRemovingHospitalId(id)
          }}
        />
      )}
    </Page>
  )
}

export default AdminHospitals
